import { NavLink as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  ListItem,
  ButtonBase,
  Typography,
} from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import UtilService from "../../../../helper/service";
import roles from "../../../../helper/roles";

const useStyles = makeStyles<Theme>(theme =>
  createStyles({
    root: {
      padding: 0
    },
    content: {
      flexGrow: 1,
      height: 40,
      color: theme.palette.text.secondary,
      borderRadius: 4,
      paddingRight: 18,
      paddingLeft: 7,
      marginLeft: 15,
      fontWeight: 'lighter',
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      }
    },
    active: {
      fontWeight: 'bold',
      backgroundColor: theme.palette.action.selected,
      color: '#017AEF',
    },
    label: {
      fontWeight: 'inherit',
      color: 'inherit'
    },
    labelRoot: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 0)
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    text: {
      fontWeight: 'inherit',
      flexGrow: 1
    }
  }));

function LabelItem({ label, onClick, ...rest }: any) {
  const classes = useStyles();
  const location = useLocation();

  const getTo = (label: any) => {
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
    let baseUrl = '/user/profile';
    if (!!loginUserData) {
      if (UtilService.checkTrialAccess(loginUserData, roles['trial']['profile'])) {
        baseUrl = '/subscriber/user/profile';
      }
    }
    return `${baseUrl}/${label.id}`;
  };

  const getLabelId = () => {
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
    if (!!loginUserData) {
      if (UtilService.checkTrialAccess(loginUserData, roles['trial']['profile'])) {
        return location.pathname.substr(25);
      }
    }
    return location.pathname.substr(14);
  };

  return (
    <ListItem
      className={classes.root}
      onClick={onClick}
      {...rest}
    >
      <ButtonBase
        activeClassName={classes.active}
        component={RouterLink}
        to={() => getTo(label)}
        className={classes.content}
      >
        <img
          alt="Logo"
          src={getLabelId() === label.id ? label.img2 : label.img1}
          style={{ width: 25, height: 25, marginRight: 6 }}
        />
        <Typography
          className={classes.text}
          variant="body2"
        >
          {label.name}
        </Typography>
      </ButtonBase>
    </ListItem>
  );
}

LabelItem.propTypes = {
  label: PropTypes.object.isRequired,
  children: PropTypes.any,
  onClick: PropTypes.func
};

export default LabelItem;
